module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-t-sm m-b-sm"
  }, [_c('a', {
    staticClass: "btn btn-default font-bold btn-dark",
    on: {
      "click": _vm.toggleShow
    }
  }, [_vm._v(_vm._s(_vm.show ? 'Cancelar' : 'Alterar pix pagador'))])]), _vm._v(" "), (_vm.show) ? _c('popup-viewer-alert', {
    attrs: {
      "title": "Alteração manual de pix pagador"
    }
  }, [_c('div', {
    staticClass: "form-group m-t-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pixPagador),
      expression: "pixPagador"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.pixPagador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pixPagador = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "end",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default m-l",
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info m-l",
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.setPixPagador
    }
  }, [_vm._v("Confirmar")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-689c8f8e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/BtnAlteraPixPagador.vue
// module id = 2191
// module chunks = 8